<template>
  <div class="fintech">
    <div class="fintech_header">
      <div class="con">
        <p>北京燕*购买了该商品 西安林*购买了该商品 上海刘*购买了该商品</p>
      </div>
    </div>
    <div class="fintech_project">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <img src="./assets/t2-k-vyTssG.png" alt=""/>
        </van-swipe-item>
        <van-swipe-item>
          <img src="./assets/t3-DNlgZ674.png" alt=""/>
        </van-swipe-item>
      </van-swipe>
      <div class="fintech_project-price">
        <div class="price">￥198<span>￥1280</span></div>
        <div class="name">每日坚果</div>
        <div class="tip">
          <span>滋补身体</span>
          <span>美味可口</span>
          <span>鲜香酥脆</span>
        </div>
        <div class="sale">
          <span>99%好评</span>
          <span>一小时热卖一万单</span>
        </div>
        <div class="srive">
          <span class="srive-fw">服务</span>
          <span>
            <van-icon name="passed" color="red" />七天无理由
            <van-icon name="passed" color="red" />先试吃
            <van-icon name="passed" color="red" />消费者权益保证中
          </span>
        </div>
      </div>
    </div>
    <div class="fintech_detail">
     <div class="fintech_detail-tabs">
      <span @click="changeTabs(index)" :class="{'active': active == index}" v-for="(item, index) in tabsList" :key="index">{{item}}</span>
     </div>
     <div class="fintech_detail-content">
      <div class="imageList" v-if="active == 0">
        <img src="./assets/l1-ol1Q_EP_.png" alt="">
        <img src="./assets/l2-vY_pUBKE.png" alt="">
        <img src="./assets/l3-CHKFHgan.png" alt="">
      </div>
     </div>
    </div>
    <div class="fintech_order">
      <p class="title">订单信息</p>
      <div class="order">
        <img src="./assets/del-BTMFFRxV.png" alt="">
        <div class="order-msg">
          <p class="name">每日坚果</p>
          <p class="price">￥199</p>
        </div>
      </div>
      <div class="menu">
        <p class="menu-title">套餐信息</p>
        <p class="menu-con">
          <span :class="{'active': orderNumIndex == index}" @click="changeOrderNum(index)" v-for="(item, index) in orderNum" :key="index">{{item}}</span>
        </p>
      </div>
      <div class="num">
        <p>购买数量</p>
        <van-stepper v-model="numValue" />
      </div>
      <div class="desyou">
        <div class="desyou-item">
          <span>优惠券</span>
          <span>暂无</span>
        </div>
        <div class="desyou-item">
          <span>运费</span>
          <span>暂无</span>
        </div>
        <div class="desyou-item">
          <span>实付金额</span>
          <span style="color: red">￥{{ newPrice }}</span>
        </div>
      </div>
    </div>
    <div class="fintech_message">
      <p class="title">收货信息</p>
      <van-form >
        <van-cell-group inset>
          <van-field
            v-model="form.userName"
            name="收货人"
            label="收货人"
            placeholder="请填写姓名"
            :rules="[{ required: true, message: '请填写用户名' }]"
          />
          <van-field
            v-model="form.phone"
            name="联系方式"
            label="联系方式"
            placeholder="请填写手机号码"
            :rules="[{ required: true, message: '请填写联系方式' }]"
          />
          <van-field
            v-model="form.area"
            name="地区"
            label="地区"
            placeholder="地区"
            readonly
            @click="openAreaPop"
            :rules="[{ required: true, message: '请填写地区' }]"
          />
          <van-field
            v-model="form.address"
            name="详细地址"
            label="详细地址"
            placeholder="请填写详细地址"
            :rules="[{ required: true, message: '请填写地区' }]"
          />
          <van-field
            v-model="form.remark"
            name="买家留言"
            label="买家留言"
            placeholder="(选填)快递等特殊要求"
            :rules="[{ required: true, message: '请填写地区' }]"
          />
        </van-cell-group>
      </van-form>
      <p class="tip"><van-icon name="checked" />记录收货地址，再次购买时自动输入</p>
      <p class="tip"><van-icon name="checked" />我已阅读并同意<span><router-link to="/privacy">《隐私协议》</router-link></span></p>
      <van-button type="danger" size="small" block @click="submitForm">提交订单</van-button>
    </div>
    <div class="fintech_footer" @click="openWindow">
      浙ICP备2025177397号-1
    </div>
    <van-popup v-model:show="areaShow" position="bottom">
      <van-area @confirm="onConfirm" @cancel="onCancel" :area-list="areaList" />
    </van-popup>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
// import axios from 'axios'

export default {
  name: 'App',
  data() {
    return {
      active: 0,
      tabsList: ['商品详情','规格参数'],
      numValue: 0,
      orderNum: ['坚果一袋','坚果二袋','坚果三袋','坚果四袋'],
      orderNumIndex: 0,
      form: {},
      areaShow: false,
      areaList 
    }
  },
  computed: {
    newPrice() {
      return (this.orderNumIndex + 1) * (this.numValue == 0 ? 1 : this.numValue)  * 199;
    }
  },
  methods: {
    changeTabs(idx) {
      this.active = idx;
    },
    changeOrderNum(idx) {
      this.orderNumIndex = idx;
    },
    openAreaPop() {
      this.areaShow = true;
    },
    onConfirm(value) {
      console.log(value)
      if (value) {
        let areaName = value.map(item => item.name).join('');
        this.form.area = areaName;
        this.areaShow = false;
      }
    },
    onCancel() {
      this.areaShow = false;
    },
    submitForm() {
      if (this.form.userName && this.form.phone && this.form.area) {
        this.$toast('订单提交成功，等待客服联系')
      } else {
        this.$toast.fail('请填写完整信息')
      }
      
      // axios.post('/api/process_form.php', this.form)
      //   .then(response => {
      //     // 处理成功响应
      //     console.log('提交成功', response.data)
      //     this.$toast.success('订单提交成功')
      //   })
      //   .catch(error => {
      //     // 处理错误
      //     console.error('提交失败', error)
      //     this.$toast.fail('提交失败，请重试')
      //   })
    },
    openWindow() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    }
  }
}
</script>
<style>
#app {
  margin: 0;
  padding: 0;
  height: 100%;
 
}
</style>
<style lang="less" scoped>
.fintech {
  padding-top: 10px;
  background: linear-gradient(to bottom,#5674d3,#f0f0f0);
  &_header {
    height: 35px;
    margin: 0 20px;
    border-radius: 10px;
    margin-bottom: 25px;
    background: #fff url("./assets/notice.png") 3rem center no-repeat;
    background-size: 20px 20px;
    .con {
      width: calc(100% - 8rem);
      height: 35px;
      line-height: 35px;
      margin-left: 8rem;
      overflow: hidden;
      color:rgb(144, 180, 226);
      overflow: hidden; /* 添加overflow隐藏 */
      position: relative; /* 添加相对定位 */
    }
    p {
      font-size: 14px;
      margin: 0;
      white-space: nowrap; /* 禁止换行 */
      position: absolute; /* 绝对定位 */
      animation: scrollText 15s linear infinite; /* 添加动画 */
    }
  }
  /* 添加滚动动画 */
  @keyframes scrollText {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
    }
  }
  &_project {
    .van-swipe-item {
     height: 320px;
     img {
       width: 100%;
       height: 100%;
       border-radius: 10px;
     }
    }
    &-price {
      background: #fff;
      width: 90%;
      margin: 0 auto;
      padding: 25px 5%;
      .price {
        font-size: 18px;
        color: #ff5777;
        font-weight: bold;
        span {
          font-size: 14px;
          color: #999;
          display: inline-block;
          margin-left: 5px;
          font-weight: normal;
        }
      }
      .name {
        font-size: 16px;
        color: #333;
        margin: 15px 0;
      }
     .tip {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        span {
          background: #fdf2f2;
          border: .5px solid #fcb8b7;
          color: #f33531;
          padding: 4px 10px;
          font-size: 13px;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      .sale {
        width: 100%;
        height: 30px;
        background: url("./assets/bf.png") no-repeat;
        background-size: 100% 100%;
        margin: 15px 0 12px 0;
        display: flex;
        justify-content: space-around;
        align-content: center;
        color:#fff;
        span {
          line-height: 30px;
          &:first-child {
            margin-right: 50px;
          }
        }
      }
      .srive {
        color: #999;
        font-size: 12px;
        &-fw {
          color:#333;
          font-size: 16px;
          margin-right: 10px;
          display: inline-block;  
        }
      }
     }
  }
  &_detail {
    &-tabs {
      width: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 16px 0;
      background: #fff;
      margin-top: 20px;
      span {
        font-size: 14px;
        color: #333;
        padding-bottom: 10px;
        &.active {
          border-bottom: 1px solid #9f9f9f;
        }
      }
    }
    &-content {
      .imageList {
        display: flex;
        flex-direction: column;
        img {
          width: 100%;
          height: 456px;
        }
      }
    }
  }
  &_order {
    background: #fff;
    margin: 20px 0;
    padding: 20px;
    .title {
      font-size: 16px;
      color: #333;
      margin: 0 20px 10px 20px;
    }
    .order {
      display: flex;
      border-bottom: 1px solid #eee;
      padding-bottom: 20px;
      img {
        width: 120px;
        height: 120px;
      }
      &-msg {
        margin-left: 20px;
        .name {
          font-size: 16px;
          color: #333;
          margin: 10px 0;
        }
        .price {
          font-size: 14px;
          color: red;
        }
      }
    }
    .menu {
      &-title {
        color: rgb(51, 51, 51);
        font-size: 18px;
        margin-bottom: 20px;
      }
      &-con {
        display: flex;
        border-bottom: 1px solid #eee;
        font-size: 12px;
        justify-content: space-between;
        padding-bottom: 20px;
        span {
          width: 19%;
          border: 1px solid #eee;
          padding: 2px 6px;
          text-align: center;
          border-radius: 4px;
          &.active {
            color: #f33531;
            border: 1px solid #f33531;
            width: 19%;
            padding: 2px 6px;
            text-align: center;
            border-radius: 4px;
          }
        }
      }
    }
    .num {
      margin: 20px auto 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eee;
      padding-bottom: 10px;
      p{
        font-size: 18px;
        margin-bottom: 20px;
      }
    }
    .desyou {
      &-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
        color: #333;
        font-size: 14px;
      }
    }
    
  }
  &_message{
    background: #fff;
    margin: 20px 0;
    padding-bottom: 20px;
    :deep .van-cell {
      padding: 10px 0;
    }
    :deep .van-button {
      width: 90%;
      margin: 15px auto;
      border-radius: 10px;
      
    }
    .title {
      font-size: 16px;
      color: #333;
      margin: 0 20px 10px 20px;
      padding-top: 20px;
    }
    .tip {
      color: #666;
      font-size: 14px;
      width: 90%;
      margin: 0 auto 18px auto;
    }
  }
  &_footer {
    margin: 10px 0px;
    width: 100%;
    text-align: center;
    padding: 30px 0px;
    font-size: 16px;
  }
}
</style>
